import { computed, inject, toRef, unref, ref } from 'vue';
import mime from 'mime';
import toSafeInteger from 'lodash/toSafeInteger';

export const useDccsField = props => {
    const required = ref(props.required);
    const normalizedRequired = computed(() => required.value === true || required.value === 'true');

    const setRequired = changed => {
        required.value = changed;
    };

    const optionalAppend = inject('optionalAppend');
    const prefersOptional = inject('prefersOptional');
    const requiredAppend = inject('requiredAppend');

    const label = toRef(props, 'label');
    const labelText = computed(() => {
        if (normalizedRequired.value !== true && prefersOptional === true) {
            return label.value.endsWith(optionalAppend) ? unref(label) : `${unref(label)} ${optionalAppend}`;
        }

        if (normalizedRequired.value === true && prefersOptional.value !== true) {
            return requiredAppend === null || label.value.endsWith(requiredAppend)
                ? unref(label)
                : `${unref(label)} ${requiredAppend}`;
        }

        return unref(label);
    });

    const accept = toRef(props, 'accept');
    const normalizedAccept = computed(() => {
        if (accept.value === null || !accept.value.length) {
            return null;
        }

        const acceptArray = [];
        accept.value.split(',').map(ext => {
            let mimeType = mime.getType(ext);
            if (mimeType !== null) {
                acceptArray.push(mimeType);
            }
        });

        return acceptArray;
    });
    const normalizedAcceptString = computed(() => {
        if (unref(normalizedAccept) === null || !unref(normalizedAccept).length) {
            return null;
        }

        return unref(normalizedAccept).join(',');
    });

    const maxFileSize = toRef(props, 'maxFileSize');
    const normalizedMaxFilesize = computed(() =>
        unref(maxFileSize) === null ? null : toSafeInteger(unref(maxFileSize))
    );

    const isMultiple = toRef(props, 'isMultiple');
    const normalizedIsMultiple = computed(() => unref(isMultiple) === true || unref(isMultiple) === 'true');

    const cols = toRef(props, 'cols');
    const normalizedCols = computed(() => (unref(cols) ? toSafeInteger(unref(cols)) : null));

    const rows = toRef(props, 'rows');
    const normalizedRows = computed(() => (unref(rows) ? toSafeInteger(unref(rows)) : null));

    const maxlength = toRef(props, 'maxlength');
    const normalizedMaxlength = computed(() => (unref(maxlength) ? toSafeInteger(unref(maxlength)) : null));

    return {
        normalizedRequired,
        setRequired,
        labelText,
        normalizedAccept,
        normalizedAcceptString,
        normalizedMaxFilesize,
        normalizedIsMultiple,
        normalizedCols,
        normalizedRows,
        normalizedMaxlength,
    };
};
